<script setup lang="ts">
import LGHowToUseContent from "~/components/partials/LGHowToUseContent.vue";
const { t } = useI18n()
const localePath = useLocalePath()
</script>

<template>
    <section class="py-12 sm:py-12 relative overflow-x-clip">
        <NuxtImg src="/images/home-page/how-to-pin.svg" alt="Pin" class="w-[244px] lg:w-[360px] absolute -top-24 lg:-top-48 -right-[160px] lg:right-0" />
        <LGHowToUseContent/>
        <UContainer class="text-center">
            <UButton color="primary" variant="solid" :to="localePath('vodici')" class="w-fit mx-auto mt-16">{{ t("home.howTo.button") }}</UButton>
        </UContainer>
    </section>
</template>

<style scoped>

</style>
